document.addEventListener('DOMContentLoaded', function () {
  const swiperMap = new Map();
  let activeSwiper = null;
  let isScrolling = false;
  let lockedVerticalScroll = false;

  function lockBodyScroll() {
    document.body.style.overflowY = 'hidden';
    // Apply right margin only on desktop (≥1024px)
    if (window.innerWidth >= 1024) {
      document.body.style.marginRight = '15px';
    } else {
      document.body.style.marginRight = '';
    }
  }

  function unlockBodyScroll() {
    document.body.style.overflowY = '';
    document.body.style.marginRight = '';
  }

  function isElementNearViewportCenter(el, tolerance = 150) {
    const rect = el.getBoundingClientRect();
    const winCenter = window.innerHeight / 2;
    const elTop = rect.top - tolerance;
    const elBottom = rect.bottom + tolerance;
    return winCenter >= elTop && winCenter <= elBottom;
  }

  function getCenterSwiper() {
    let best = null;
    let bestDist = Infinity;
    const winCenter = window.innerHeight / 2;

    swiperMap.forEach((swiper, section) => {
      const rect = section.getBoundingClientRect();
      const elCenter = rect.top + rect.height / 2;
      const dist = Math.abs(elCenter - winCenter);
      if (dist < bestDist) {
        best = { swiper, section, dist };
        bestDist = dist;
      }
    });

    return best;
  }

  function updateActiveSwiperFromScroll() {
    const candidate = getCenterSwiper();
    if (!candidate) return;

    if (isElementNearViewportCenter(candidate.section)) {
      activeSwiper = candidate.swiper;
    } else if (activeSwiper === candidate.swiper) {
      activeSwiper = null;
    }
  }

  // Initialize all Swipers and map them to sections
  document.querySelectorAll('.multicolumn-swiper').forEach((swiperEl) => {
    const swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 25,
      allowTouchMove: true,
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 25 },
        768: { slidesPerView: "auto", spaceBetween: 25 }
      }
    });

    const section = swiperEl.closest('.swiper-section') || swiperEl;
    swiperMap.set(section, swiper);
  });

  document.querySelectorAll('.testimonial-slider').forEach((swiperEl) => {
    const swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      allowTouchMove: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        0: { spaceBetween: 26 },
        768: { spaceBetween: 47 }
      }
    });

    const section = swiperEl.closest('.swiper-section') || swiperEl;
    swiperMap.set(section, swiper);
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const swiper = swiperMap.get(entry.target);
      if (!swiper) return;

      if (entry.isIntersecting && isElementNearViewportCenter(entry.target)) {
        activeSwiper = swiper;
      } else if (activeSwiper === swiper) {
        activeSwiper = null;
      }
    });
  }, { threshold: 0.5 });

  swiperMap.forEach((_, section) => observer.observe(section));

  window.addEventListener('scroll', () => {
    if (updateActiveSwiperFromScroll._rAF) return;
    updateActiveSwiperFromScroll._rAF = requestAnimationFrame(() => {
      updateActiveSwiperFromScroll();
      updateActiveSwiperFromScroll._rAF = null;
    });
  });

  window.addEventListener('wheel', (e) => {
    if (!activeSwiper || isScrolling) return;

    const swiperSection = [...swiperMap.entries()]
      .find(([section, swiper]) => swiper === activeSwiper)?.[0];

    if (!swiperSection || !isElementNearViewportCenter(swiperSection)) return;

    const delta = e.deltaY;

    if ((delta > 0 && !activeSwiper.isEnd) || (delta < 0 && !activeSwiper.isBeginning)) {
      e.preventDefault();
      isScrolling = true;
      lockedVerticalScroll = true;
      lockBodyScroll();

      if (delta > 0) {
        activeSwiper.slideNext();
      } else {
        activeSwiper.slidePrev();
      }

      setTimeout(() => {
        isScrolling = false;

        if (activeSwiper.isEnd || activeSwiper.isBeginning) {
          lockedVerticalScroll = false;
          unlockBodyScroll();
        }
      }, 350);
    } else if (lockedVerticalScroll) {
      e.preventDefault();
    }
  }, { passive: false });

  // Prevent scroll from keys during lock
  window.addEventListener('keydown', (e) => {
    if (lockedVerticalScroll && ['ArrowDown', 'ArrowUp', 'PageUp', 'PageDown', ' '].includes(e.key)) {
      e.preventDefault();
    }
  });
});
